import {
  texto,
  TipoProductoEnumChoice,
  useLoaders,
  useTableColumnsProducto,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared";
import {
  SearchComponente,
  GeneralTable,
  CustomAutocompleteNoForm,
  CustomTextFieldNoForm,

} from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { IDataProducto } from "@/shared/interfaces";
import { Button, Grid, IconButton, Tooltip } from "@mui/material";
import { useMemo, useState } from "react";
import { CATEGORYPRODUCT } from "@/shared/interfaces/erp/inventario";
import { useFetchProductoSimple } from "@/shared/actions/erp";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import { useCategoriaProductoStore } from "@/store/erp";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Add } from "@mui/icons-material";

interface ModalProductoSelectComponenteProps {
  onChange: (e: IDataProducto) => void;
  iconButton?: boolean;
  textButton?: string;
}

///* Componente para renderizar en un modal todos los productos

export default function ModalProductoSelectComponente({
  iconButton = false,
  onChange,
  textButton = "Agregar Item",
}: ModalProductoSelectComponenteProps) {

  ///* State
  const [selectCategoria, setSelectCategoria] = useState<string | null>(
    null
  );

  const [openModalProducto, setOpenModalProducto] = useState<boolean>(false);

  ///* Hooks y Store
  const {
    categoriaProductos,
    isLoadingCategoriaProducto
  } = useCategoriaProductoStore();

  const { columnsSelectProductoModal } = useTableColumnsProducto();
  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } = useTableServerSideFiltering();

  const {
    globalFilter,
    setGlobalFilter,
    pagination,
    onChangeFilter,
    searchTerm,
    setPagination,
    cleanFilter
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  //FETCH
  const {
    isLoading: isloadingProducto,
    data: productoRes,
    isRefetching: isRefetchingProducto
  } =
    useFetchProductoSimple({
      params: {
        page: pageIndex + 1,
        page_size: pageSize,
        //codigo: searchTerm,
        descripcion: searchTerm,
        categoria_producto: selectCategoria,
        estado: true,
        ...filterObject,
        filterByState: false
      },
      enabled: true,
      //enabled: !!selectCategoria || !!searchTerm
    },
    );

  //*
  /* useEffect(() => {
    if (!openModalProducto) {
      setGlobalFilter("")
    }
  }, [openModalProducto]) */

  const categoriasConTodos = useMemo<CATEGORYPRODUCT[]>(() => [
    { codigo: '', nombre: "TODOS", estado: true },
    ...(categoriaProductos ?? []),
  ], [categoriaProductos]);

  useLoaders(isloadingProducto);

  return (
    <>
      {iconButton ? (
        <Tooltip placement="top" title="Todos los inventariables">
          <IconButton onClick={() => setOpenModalProducto(true)} size="medium">
            <ManageSearchIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          startIcon={<Add />}
          variant="outlined"
          endIcon={<AddCircleIcon/>}
          onClick={() => {
            setOpenModalProducto(true);
          }}
        >
          {textButton}
        </Button>
      )}

      {openModalProducto && (
        <ScrollableDialogProps
          open={openModalProducto}
          title="Seleccionar Inventaribale"
          //cancelTextBtn="Cerrar"
          onCloseIcon={() => {
            setSelectCategoria(null);
            setGlobalFilter("")
            cleanFilter();
            setOpenModalProducto(false);
          }}
          minWidth="70%"
          contentNode={
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <SearchComponente
                  onChange={onChangeFilter}
                  value={globalFilter}
                  text="por descripción" />
              </Grid>

              <Grid item xs={3}>
                <CustomTextFieldNoForm
                  required={false}
                  disabled={true}
                  label="Tipo producto"
                  value={TipoProductoEnumChoice.INVENTARIABLE}
                  defaultValue={TipoProductoEnumChoice.INVENTARIABLE}
                />
              </Grid>
              <Grid item xs={3}>
                <CustomAutocompleteNoForm<CATEGORYPRODUCT>
                  label={texto.categoria_producto}
                  options={categoriasConTodos || []}
                  valueKey="nombre"
                  actualValueKey="codigo"
                  defaultValue={selectCategoria || ""}
                  isLoadingData={isLoadingCategoriaProducto}
                  onChangeRawValue={(e) => {
                    if (e) {
                      cleanFilter();
                      setSelectCategoria(e.codigo);
                      return
                    }
                    setSelectCategoria(null);

                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <GeneralTable<IDataProducto>
                  columns={columnsSelectProductoModal}
                  data={productoRes?.data.data || []}
                  isLoading={isloadingProducto}
                  isRefetching={isRefetchingProducto}
                  enableGlobalFilter={false}
                  pagination={pagination}
                  onPaging={setPagination}
                  rowCount={productoRes?.data?.count}
                  actionsColumnSize={120}
                  canDelete={false}
                  positionActionsColumn='first'
                  enableColumnActions={true}
                  canAdd={true}
                  canEdit={false}
                  onAdd={e => {
                    onChange(e);
                  }}
                  density="comfortable"
                  enableTopToolbar={false}
                  ///* filters - server side
                  enableSorting={false}
                  enableManualFiltering={true}
                  columnFilters={columnFilters}
                  onColumnFiltersChange={setColumnFilters}
                />
              </Grid>
            </Grid>
          }
        />
      )}
    </>
  );
}
